import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Avatar } from '@mui/material'
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material'

const TypingIndicator = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
      }}
    >
      <Avatar
        sx={{
          background: `linear-gradient(45deg, ${theme.palette.secondary.main} 30%, ${theme.palette.info.main} 90%)`,
          '&:hover': {
            transform: 'scale(1.05)',
            transition: 'transform 0.2s ease-in-out',
          },
        }}
      >
        <AutoAwesomeIcon
          sx={{
            color: '#FFFFFF',
            fontSize: '1.5rem',
            animation: 'sparkle 1.5s infinite alternate',
            '@keyframes sparkle': {
              '0%': { opacity: 0.8, transform: 'scale(1)' },
              '100%': { opacity: 1, transform: 'scale(1.2)' },
            },
          }}
        />
      </Avatar>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          p: 2,
          bgcolor: theme.palette.grey[100],
          borderRadius: 2,
          width: 'fit-content',
        }}
      >
        {[0, 0.5, 1].map((delay, i) => (
          <Box
            key={i}
            sx={{
              width: '8px',
              height: '8px',
              backgroundColor: theme.palette.grey[500],
              borderRadius: '50%',
              animation: 'typingDot 1.5s infinite',
              animationDelay: `${delay}s`,
              opacity: 0,
              '@keyframes typingDot': {
                '0%': { 
                  opacity: 0,
                  transform: 'scale(0.8)',
                },
                '33%': { 
                  opacity: 1,
                  transform: 'scale(1.2)',
                },
                '66%': { 
                  opacity: 1,
                  transform: 'scale(1)',
                },
                '100%': { 
                  opacity: 0,
                  transform: 'scale(0.8)',
                },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  )
}

export default TypingIndicator
